import { render } from "./TheCabinetOff.vue?vue&type=template&id=624a0876"
const script = {}

import "./TheCabinetOff.vue?vue&type=style&index=0&id=624a0876&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__